/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class CAISONode extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "CAISONode";
}

const servicePlugin = makeServicePlugin({
  Model: CAISONode,
  service: feathersClient.service("data-services/caiso/nodes"),
  idField: "Node ID",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
